import api from '@/service/api';
import variables from "@/service/variables";
export default class SupervisorApplyService {
     

    GetUsers() {
        return api.get(variables.API_URL +'/api/Supervisor/GetUsers')
    }
    GetApplyList() {
        return api.get(variables.API_URL +'/api/Supervisor/GetApplyList')
    }
    GetApply(id) {
        return api.get(variables.API_URL +'/api/Supervisor/GetApply/' + id)
    }

    NewApply_Type2(){
        return api.get(variables.API_URL +'/api/Supervisor/NewApply_Type2')
    }
    
  
    
    CommitApply_Type2(applyHeader){
        return api.post(variables.API_URL +'/api/Supervisor/CommitApply_Type2',  applyHeader)
    }
    DraftApply_Type2(applyHeader){
        return api.post(variables.API_URL +'/api/Supervisor/DraftApply_Type2',  applyHeader)
    }

    
    NewApply_Type3(VIPSystem) {
        return api.get(variables.API_URL +'/api/Supervisor/NewApply_Type3/' + VIPSystem)
    }
    CommitApply_Type3(lstSystemUser){
        return api.post(variables.API_URL +'/api/Supervisor/CommitApply_Type3',  lstSystemUser)
    }

    NewApply_Type4( ) {
        return api.get(variables.API_URL +'/api/Supervisor/NewApply_Type4')
    }
    CommitApply_Type4(data ) {
        return api.post(variables.API_URL +'/api/Supervisor/CommitApply_Type4',  data)
    }

    
    NewApply_Type5(email) {
        return api.get(variables.API_URL +'/api/Supervisor/NewApply_Type5/' + email)
    }
    CommitApply_Type5(data){
        return api.post(variables.API_URL +'/api/Supervisor/CommitApply_Type5',  data)
    }

    NewApply_Type6(id) {
        return api.get(variables.API_URL +'/api/Supervisor/NewApply_Type6/'+id)
    }
    CommitApply_Type6(data){
        return api.post(variables.API_URL +'/api/Supervisor/CommitApply_Type6',  data)
    }
    GetUsers4View() {
        return api.get(variables.API_URL +'/api/Supervisor/GetUsers4View')
    }
    DeleteUser(users){
        return api.post(variables.API_URL +'/api/Supervisor/DeleteUser',  users)
    }
    GetVendorAccount(userId) {
        return api.get(variables.API_URL +'/api/Supervisor/GetVendorAccount/' + userId)
    }
    UpdateVendorAccountInformation(model) {
        return api.post(variables.API_URL +'/api/Supervisor/UpdateVendorAccountInformation' , model)
    }

    GetVIPSystemAccountCount(vipsystem) {
        return api.get(variables.API_URL +'/api/Supervisor/GetVIPSystemAccountCount/' + vipsystem)
    }

    CheckUserInApply(lstEMail){
        return api.post(variables.API_URL +'/api/Supervisor/CheckUserInApply',  lstEMail)
    }



    GetVendorCode4() {
        return api.get(variables.API_URL +'/api/Supervisor/GetVendorCode4')
    }
 GetVendorCode4History() {
        return api.get(variables.API_URL +'/api/Supervisor/GetVendorCode4History')
    }



    NewVendorCode4ChangeData(vendorcode) {
        return api.get(variables.API_URL +'/api/Supervisor/NewVendorCode4ChangeData/'+ vendorcode)
    }

GetModifyVendorCode4ChangeData(TranscationId) {
        return api.get(variables.API_URL +'/api/Supervisor/GetModifyVendorCode4ChangeData/'+ TranscationId)
    }


     SaveVendorCode4ChangeData(data) {
        return api.post(variables.API_URL +'/api/Supervisor/SaveVendorCode4ChangeData' , data)
    }
SaveVendorCode4ChangeDataAndSendEForm(data) {
        return api.post(variables.API_URL +'/api/Supervisor/SaveVendorCode4ChangeDataAndSendEForm' , data)
    }

 GetCountry() {
        return api.get(variables.API_URL +'/api/Supervisor/GetCountry')
    }

    
}
    